import { render, staticRenderFns } from "./FunctionSwitchListPage.vue?vue&type=template&id=19a3507c&scoped=true"
import script from "./FunctionSwitchListPage.vue?vue&type=script&lang=js"
export * from "./FunctionSwitchListPage.vue?vue&type=script&lang=js"
import style0 from "./FunctionSwitchListPage.vue?vue&type=style&index=0&id=19a3507c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a3507c",
  null
  
)

export default component.exports